import React from 'react';
import { Loader2 } from 'lucide-react';

export default function AnalyticsTab({ analyticsOverview }) {
  return (
    <div data-testid="analytics-section">
      {analyticsOverview ? (
        <div className="space-y-6">
          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="bg-gradient-to-br from-emerald-900/40 to-emerald-800/20 border border-emerald-500/30 rounded-xl p-4">
              <p className="text-emerald-400 text-sm font-medium">Total Content</p>
              <p className="text-3xl font-bold text-white mt-1" data-testid="analytics-total-content">{analyticsOverview.total_content}</p>
            </div>
            <div className="bg-gradient-to-br from-blue-900/40 to-blue-800/20 border border-blue-500/30 rounded-xl p-4">
              <p className="text-blue-400 text-sm font-medium">Total Views</p>
              <p className="text-3xl font-bold text-white mt-1" data-testid="analytics-total-views">{analyticsOverview.total_views?.toLocaleString()}</p>
            </div>
            <div className="bg-gradient-to-br from-purple-900/40 to-purple-800/20 border border-purple-500/30 rounded-xl p-4">
              <p className="text-purple-400 text-sm font-medium">Plays (7 days)</p>
              <p className="text-3xl font-bold text-white mt-1" data-testid="analytics-recent-plays">{analyticsOverview.recent_plays_7d}</p>
            </div>
            <div className="bg-gradient-to-br from-red-900/40 to-red-800/20 border border-red-500/30 rounded-xl p-4">
              <p className="text-red-400 text-sm font-medium">Live Now</p>
              <p className="text-3xl font-bold text-white mt-1" data-testid="analytics-live-now">{analyticsOverview.active_live_streams}</p>
            </div>
          </div>

          {/* Top Content */}
          <div className="bg-[#222] rounded-xl p-6">
            <h3 className="text-lg font-bold text-white mb-4">Top Content by Views</h3>
            <div className="space-y-3">
              {analyticsOverview.top_content?.map((item, i) => (
                <div key={item.id} className="flex items-center gap-4 p-3 bg-[#1a1a1a] rounded-lg" data-testid={`top-content-${i}`}>
                  <span className="text-gray-500 font-mono w-6">{i + 1}.</span>
                  <div className="flex-1 min-w-0">
                    <p className="text-white font-medium truncate">{item.title}</p>
                    <p className="text-gray-400 text-sm">{item.teams}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-emerald-400 font-bold">{item.views?.toLocaleString()}</p>
                    <p className="text-gray-500 text-xs">views</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center py-16">
          <Loader2 className="w-8 h-8 animate-spin text-emerald-500" />
        </div>
      )}
    </div>
  );
}
